import { render, staticRenderFns } from "./Fertilite.vue?vue&type=template&id=8691f4a6&"
import script from "./Fertilite.vue?vue&type=script&lang=js&"
export * from "./Fertilite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports